document.addEventListener('DOMContentLoaded', () => {
    let lastDispatchedId = null;

    const dispatchWhenReady = () => {
        const openModal = document.querySelector('quick-view-modal[open], quick-view-modal.modal--open');
        
        if (!openModal) {
            lastDispatchedId = null; 
            return;
        }

        const form = openModal.querySelector(
            '[bss-b2b-quickview-product-form]'
        );
        const productIdElem = openModal.querySelector('[bss-b2b-product-id]');
        const productId = productIdElem?.getAttribute('bss-b2b-product-id') || openModal.id;

        if (form && productIdElem && productId !== lastDispatchedId) {
            lastDispatchedId = productId;
            
            document.dispatchEvent(
                new Event('bss_b2b:QuickviewLoaded', { bubbles: true })
            );
        }
    };

    new MutationObserver(() => {
        dispatchWhenReady();
    }).observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['open', 'class']
    });
});
